var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow-right_1_","d":"M-33.7 9.5l-4.1 4.1c-.1.1-.2.2-.4.2-.1 0-.3 0-.4-.2-.2-.2-.2-.5 0-.7l2.9-2.9h-16.2c-.3 0-.5-.2-.5-.5s.3-.5.6-.5h16.2l-2.9-2.9c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l4.1 4.1z","transform":"translate(52.914 .354)"}));
}

IconArrowRight.defaultProps = {"id":"arrow-right","x":"0","y":"0","version":"1.1","viewBox":"0 0 19.8 19.8","xmlSpace":"preserve"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
